module.exports = __webpack_public_path__ + "static/img/research.0a1cbace.png";